import React from 'react';
import ReactJson from '@microlink/react-json-view';

/**
 * JSON in the catalogue, read the way the service item detail page reads a
 * declaration: the same viewer with the same options, in a panel of its own.
 * A schema and a declaration are two halves of one conversation, so looking at
 * one should not feel like a different product from looking at the other.
 */
const ServiceJson = ({ data }: { data: any }) => {
    const empty = !data || (typeof data === 'object' && Object.keys(data).length === 0);

    if (empty) return <div className="svc-empty">Nothing to show here.</div>;

    return (
        <div className="svc-json">
            <ReactJson
                style={{ padding: '16px', background: 'transparent' }}
                src={data}
                displayDataTypes={false}
                name={null}
                displayArrayKey={false}
                displayObjectSize={false}
            />
        </div>
    );
};

export default ServiceJson;
